/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt24@ghtk.vn on 11/08/2020.
 * @module APP CONSTANTS
 */

// Action constants
const MODULE_NAME = "APP/";

// Actions type
export const BROWSE_REPOSITORIES = `${MODULE_NAME}BROWSE_REPOSITORIES`;
export const BROWSE_ALL_STATION = `${MODULE_NAME}BROWSE_ALL_STATION`;
export const BROWSE_OWN_STATION = `${MODULE_NAME}BROWSE_OWN_STATION`;
export const BROWSE_OWN_COMPANY_STATION = `${MODULE_NAME}BROWSE_OWN_COMPANY_STATION`;
export const GET_MENU = `${MODULE_NAME}GET_MENU`;
export const GET_STRICTED_ROUTE = `${MODULE_NAME}GET_STRICTED_ROUTE`;
export const GET_All_STATION = `${MODULE_NAME}GET_All_STATION`;
export const GET_USER_STATION = `${MODULE_NAME}GET_USER_STATION`;
export const GET_All_HARDWARE = `${MODULE_NAME}GET_All_HARDWARE`;
export const SET_LIST_SERVER = `${MODULE_NAME}SET_LIST_SERVER`;
export const BROWSE_STATION_V2 = `${MODULE_NAME}BROWSE_STATION_V2`;

// Station type
export const STATION_TYPE = {
  LIEN_VUNG: 0,
  NOI_VUNG: 1
};
// Station type
export const ORDER_TYPE = {
  BIG_SIZE: 14,
  ROAD: "road",
  FLY: 16
};

//format time
export const TIME_FORMAT_DATE_TIME = "DD/MM/YYYY HH:mm:ss";
export const TIME_FORMAT_WITHOUT_TIME = "DD/MM/YYYY";
export const TIME_FORMAT_WITHOUT_DATE = "HH:mm:ss";

// default value
export const DEFAULT_VALUE = "-";


export const TASK_TYPE = {
  SHIFT_BEGIN: {
    text: "Kiểm tra hàng ngày",
    color: "#069255",
  },
  PERIODIC: {
    text: "Bảo dưỡng định kỳ",
    color: "#Bdbdbd",
  },
  REPAIR: {
    text: "Sửa chữa",
    color: "#ffc107",
  },
  INCIDENT: {
    text: "Sự cố",
    color: "#EB5757",
  },
};